/**
 * 应用信息管理模块
 * zxw
 * 创建时间 2026-04-17
 */

import CNF from '../../../incs/Config.js';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    ShowIPModal,
    GetButtonActionName,
    rootReactDom,
    BooleanToCN,
} from '../../../incs/FunHelper.js';
import { Component } from 'react';
import $ from 'jquery';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Tag,
    theme,
    Button,
    Tooltip,
    Space,
} from 'antd';
import {
    RetweetOutlined,
} from '@ant-design/icons';
import { generate } from '@ant-design/colors';

// 引入组件
import AppinfoBooleanPatchModel from './AppinfoBooleanPatchModel.js';


// const MODULENAME = CNF.navItems[0].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[0].ptn;

const Lists = (props) => {
    const {
        token: {
            colorPrimary,           // 主色


        },
    } = theme.useToken();

    const renderAppinfoBooleanPatchModel = (record, action, params) => {
        rootReactDom && rootReactDom.render(
            <AppinfoBooleanPatchModel
                isRefresh={props.isRefresh}
                open={true}
                record={record}
                action={action}
                params={params}
            />
        );
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        // switch (action) {
        //     case CNF.actionName.PUBLISH:
        //         renderAppinfoBooleanPatchModel(record);
        //         break;
        //     default:
        //         break;

        // }
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '应用Id', dataIndex: 'app_id', key: 'app_id', },
        { title: '应用名称', dataIndex: 'app_name', key: 'app_name', },
        { title: '应用类型', dataIndex: 'app_type', key: 'app_type', },
        { title: '应用领域', dataIndex: 'app_filed', key: 'app_filed', },
        {
            title: '应用标签', key: 'app_tags',
            render: (record) => record.app_tags ? <Space>{record.app_tags.split('|').map((tag, index) => (
                <Tag key={index} size='small' color='green'>{tag}</Tag>
            ))}</Space> : '-'
        },
        {
            title: '是否发布', key: 'is_release',
            render: (record) => <Tag size='small' style={{ color: colorPrimary }} color={generate(colorPrimary)[0]}>{BooleanToCN(record.is_release)}</Tag>
        },
        {
            title: '是否精选', key: 'is_suggest',
            render: (record) => <Tooltip title={record.is_suggest ? '取消精选' : '精选应用'}><Button variant='filled' size='small' color='primary' style={{ fontSize: CNF.fontSizeSM }} icon={<RetweetOutlined />} onClick={() => {
                renderAppinfoBooleanPatchModel(record, record.is_suggest ? '取消精选' : '精选应用', { is_suggest: record.is_suggest ? 0 : 1 });

            }}>{BooleanToCN(record.is_suggest)}</Button></Tooltip>
        },
        {
            title: '是否公开', key: 'is_public',
            render: (record) => <Tooltip title={record.is_public ? '取消公开' : '公开应用'}>
                <Button
                    variant='filled'
                    size='small'
                    color='primary'
                    style={{ fontSize: CNF.fontSizeSM }}
                    icon={<RetweetOutlined />}
                    disabled={!record.is_release}
                    onClick={() => {
                        renderAppinfoBooleanPatchModel(record, record.is_public ? '取消公开' : '公开应用', { is_public: record.is_public ? 0 : 1 });

                    }}>{BooleanToCN(record.is_public)}</Button>
            </Tooltip>
        },
        {
            title: '是否发行', key: 'is_publish', hidden: props.btnLists.indexOf(MODULENAME_PTN + '_publish') > 0 ? false : true,
            render: (record) => <Tooltip title={record.is_publish ? '取消发行' : '发行应用'}><Button variant='filled' size='small' color='primary' style={{ fontSize: CNF.fontSizeSM }} icon={<RetweetOutlined />} onClick={() => {
                renderAppinfoBooleanPatchModel(record, record.is_publish ? '取消发行' : '发行应用', { is_publish: record.is_publish ? 0 : 1 });

            }}>{BooleanToCN(record.is_publish)}</Button></Tooltip>
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth + 60, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条</>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            appId: '',
            appName: '',
            appTags: '',
            appFiled: '',
            isRelease: '',
            isSuggest: '',
            isPublic: '',
            isPublish: '',
            role: '',
            scene: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeAppId = (e) => { this.setState({ appId: e.target.value }); this.search(); }
    changeAppName = (e) => { this.setState({ appName: e.target.value }); this.search(); }
    changeAppTags = (e) => { this.setState({ appTags: e.target.value }); this.search(); }
    changeAppFiled = (value) => { this.setState({ appFiled: value === undefined ? '' : value }); this.search(); }
    changeIsRelease = (value) => { this.setState({ isRelease: value === undefined ? '' : value }); this.search(); }
    changeIsSuggest = (value) => { this.setState({ isSuggest: value === undefined ? '' : value }); this.search(); }
    changeIsPublic = (value) => { this.setState({ isPublic: value === undefined ? '' : value }); this.search(); }
    changeIsPublish = (value) => { this.setState({ isPublish: value === undefined ? '' : value }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value === '' ? '' : value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }


    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        let params = {
            app_id: this.state.appId,
            app_name: this.state.appName,
            app_tags: this.state.appTags,
            app_type: '',
            app_filed: this.state.appFiled,
            is_release: this.state.isRelease,
            is_suggest: this.state.isSuggest,
            is_public: this.state.isPublic,
            is_publish: this.state.isPublish,
            page_size: CNF.pageSize,
            current_index: this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}app/infos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeAppId}
                            placeholder='应用Id'
                            value={this.state.appId}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeAppName}
                            placeholder='应用名称'
                            value={this.state.appName}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeAppTags}
                            placeholder='应用标签'
                            value={this.state.appTags}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='应用领域'
                            style={{ width: '100%' }}
                            onChange={(value) => this.changeAppFiled(value)}
                            value={this.state.appFiled ? this.state.appFiled : undefined}
                            options={CNF.appFileds.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.label
                            }))}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='是否发布'
                            style={{ width: '100%' }}
                            onChange={(value) => this.changeIsRelease(value)}
                            value={this.state.isRelease ? this.state.isRelease : undefined}
                            options={CNF.booleanSelectOptions}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='是否精选'
                            style={{ width: '100%' }}
                            onChange={(value) => this.changeIsSuggest(value)}
                            value={this.state.isSuggest ? this.state.isSuggest : undefined}
                            options={CNF.booleanSelectOptions}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='是否公开'
                            style={{ width: '100%' }}
                            onChange={(value) => this.changeIsPublic(value)}
                            value={this.state.isPublic ? this.state.isPublic : undefined}
                            options={CNF.booleanSelectOptions}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='是否发行'
                            style={{ width: '100%' }}
                            onChange={(value) => this.changeIsPublish(value)}
                            value={this.state.isPublish ? this.state.isPublish : undefined}
                            options={CNF.booleanSelectOptions}
                        />
                    </Col>
                    {/* <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            style={{ width: '100%' }}
                            onChange={(value) => this.changeStatus(value)}
                            value={this.state.status ? this.state.status : undefined}
                            options={CNF.status.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.label
                            }))}
                        />
                    </Col> */}
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT